/**
 * Engage globalAdmin Shadow profile dialog state for brewery beer lists (ITT-970).
 */

import { useCallback, useContext, useState } from 'react';
import { UserContext } from '../context/UserContext';

/**
 * @returns {{
 *   onShadowProfileClick: ((beer: { id: string, name?: string }) => void) | null,
 *   shadowProfileDialogOpen: boolean,
 *   shadowProfileBeerId: string | null,
 *   shadowProfileBeerName: string | null,
 *   handleCloseShadowProfileDialog: () => void,
 * }}
 */
export default function useBreweryBeerShadowProfile() {
  const user = useContext(UserContext);
  const isGlobalAdmin = user?.isGlobalAdmin === true;
  const [dialogOpen, setDialogOpen] = useState(false);
  const [shadowBeer, setShadowBeer] = useState(null);

  const handleOpenShadowProfile = useCallback((beer) => {
    if (!beer?.id) {
      return;
    }
    setShadowBeer(beer);
    setDialogOpen(true);
  }, []);

  const handleCloseShadowProfileDialog = useCallback(() => {
    setDialogOpen(false);
    setShadowBeer(null);
  }, []);

  return {
    onShadowProfileClick: isGlobalAdmin ? handleOpenShadowProfile : null,
    shadowProfileDialogOpen: dialogOpen,
    shadowProfileBeerId: shadowBeer?.id || null,
    shadowProfileBeerName: shadowBeer?.name || null,
    handleCloseShadowProfileDialog,
  };
}
